<section>
  <div class="header">
    <h4 class="vertical-align">
      <div>{{ 'LOCATION.PIPES' | translate }}</div>
    </h4>
    <div class="vertical-align">
      <button mat-button
              [disabled]="this.loadingMenu"
              (click)="uploadMenuAsync()">
        {{'MENU.SEND_FOR_SELECT' | translate }}
      </button>
    </div>
  </div>
  <div class="table-container mat-elevation-z8">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows>

      <ng-container
        *ngFor="let column of columnsToDisplay"
        matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container [ngSwitch]="column">
            <ng-template ngSwitchCase="checkBox">
              <mat-checkbox (change)="changeCheckedAllPipes($event.checked)"
                type="checkbox"
              >
              </mat-checkbox>
            </ng-template>
            <ng-template ngSwitchCase="organization">
              <mat-form-field appearance="outline">
                <mat-label [translate]="'NAV.ORGANIZATION'"></mat-label>
                <mat-select [(ngModel)] = "selectedTableOrganizationId" (selectionChange)="selectionChange()">
                  <mat-option [value]="">All</mat-option>
                  <mat-option *ngFor="let organization of this.tableDistinctOrganizations"
                              [value]="organization.id">{{organization.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <ng-template ngSwitchCase="pipe">
              <span class = "pipe-name">{{ getColumnHeaderName(column) }}</span>
              <mat-form-field appearance="outline">
                <mat-label [translate]="'PIPES.WHERE'"></mat-label>
                <mat-select [(ngModel)] = "selectedPipeType" (selectionChange)="selectionChange()">
                  <mat-option [value]="">All</mat-option>
                  <mat-option [value]="AllAggregatorsId">All aggregators</mat-option>
                  <mat-option *ngFor="let pipeType of tableDistinctPipeTypes" [value]="pipeType">{{pipeType}}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <ng-template ngSwitchDefault>
              {{ getColumnHeaderName(column) }}
            </ng-template>
          </ng-container>
        </th>
        <td
          mat-cell *matCellDef="let element">
          <div class="wrap-cell" [ngSwitch]="column">
            <div class="cell">
              <ng-template ngSwitchCase="checkBox">
                <mat-checkbox
                  [(ngModel)]="element.checked"
                  type="checkbox"
                  [disabled]="!allowMultiplyUpload(element)"
                >
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchCase="organization">
                {{element.organization.name}}
              </ng-template>
              <ng-template ngSwitchCase="pipe">
                <div [ngClass]="{'menu-loading': element.loading}">
                  <app-pipe
                    [pipe]="element.pipe"
                    [organization]="element.organization"
                    [latestMenuStorage]="element.menuStorage"
                  >
                  </app-pipe>
                </div>
              </ng-template>
              <ng-template ngSwitchCase="uploadedAt">
                <div *ngIf="!element.startedLoading">
                  {{element.menuStorage?.uploadedAt | utcToLocal: this.dateFormat}}
                </div>
                <mat-progress-spinner
                  *ngIf="element.startedLoading"
                  mode="indeterminate"
                  [diameter]="30">
                </mat-progress-spinner>
              </ng-template>
              <ng-template ngSwitchCase="published">
                <div *ngIf="!element.startedLoading">
                  {{element.menuStorage?.published | utcToLocal: this.dateFormat}}

                  <div style="padding-top: 10px"
                       *ngIf="element.menuStorage && roleMembership.isSupport"
                  >
                    <button
                      mat-raised-button
                      matTooltip="{{ 'MENU_HISTORY.MENU_NO_PUBLISHED_TOOLTIP' | translate }}"
                      (click)="confirmPublish(element.menuStorage?.id, element.pipe.id)"
                      *ngIf="!element.menuStorage?.published"
                    >
                      <mat-icon style="color: darkred">cancel</mat-icon>
                      <span style="font-size: 90%">{{ 'MENU_HISTORY.MENU_NO_PUBLISHED' | translate }}</span>
                    </button>

                    <button
                      mat-raised-button
                      matTooltip="{{ 'MENU_HISTORY.MENU_PUBLISHED_TOOLTIP' | translate }}"
                      (click)="cancelPublish(element.menuStorage?.id, element.pipe.id)"
                      *ngIf="element.menuStorage?.published"
                    >
                      <mat-icon style="color: green">check_circle</mat-icon>
                      <span style="font-size: 90%">{{ 'MENU_HISTORY.MENU_PUBLISHED' | translate }}</span>
                    </button>
                  </div>

                </div>
                <div class="wrap-mat-progress-spinner">
                  <mat-progress-spinner
                    *ngIf="element.startedLoading"
                    mode="indeterminate"
                    [diameter]="30">
                  </mat-progress-spinner>
                </div>
              </ng-template>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: true">
      </tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplay">
      </tr>
    </table>
  </div>
  <div class="vertical-align">
    <button mat-button
            (click)="setAllIikoTestModeAsync()">
      {{'MENU.SET_ALL_IIKO_TEST_MODE' | translate }}
    </button>
  </div>
</section>
